// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {map} from 'lodash';

// Actions
import * as overlayActions from '../actions/overlay-actions';

// Components
import OverlayContainer from './overlay-container';

// Styles
import './overlay-portal.scss';

class OverlayPortal extends Component {
    renderOverlay(config, id) {
        return <OverlayContainer {...config} key={id} />;
    }

    render() {
        const {overlays} = this.props;

        return <div className="overlay-portal">{map(overlays, this.renderOverlay)}</div>;
    }
}

OverlayPortal.propTypes = {
    overlays: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        overlays: state.overlays,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(overlayActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OverlayPortal);
